module.exports = __webpack_public_path__ + "static/media/GHS.110e7f60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/normes/GHS.svg
// module id = 79
// module chunks = 0